'use strict';

require('prop-types');
var React = require('react');
var OptionInvoiceBody = require('./OptionInvoiceBody.js');
var OptionInvoiceHeader = require('./OptionInvoiceHeader.js');
var OptionInvoiceFooter = require('./OptionInvoiceFooter.js');
var VerticalSpace = require('../Layouts/VerticalSpace.js');
var Grid = require('../../DesignSystem/Layout/Grid/Grid.js');
var OptionInvoiceDescription = require('./OptionInvoiceDescription.js');
var ObjectHelper = require('../../common/ObjectHelper.js');
var Divider = require('../../node_modules/@material-ui/core/esm/Divider/Divider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var OptionInvoicePreview = function OptionInvoicePreview(_ref) {
  var option = _ref.option,
      customer = _ref.customer,
      address = _ref.address,
      organization = _ref.organization,
      pro = _ref.pro,
      settings = _ref.settings,
      preparedDate = _ref.preparedDate,
      tax = _ref.tax,
      discounts = _ref.discounts,
      lendingPromo = _ref.lendingPromo,
      image = _ref.image,
      laborItems = _ref.laborItems,
      materialItems = _ref.materialItems,
      isPresenting = _ref.isPresenting;
  var mappedSettings = {
    show_technician_name: settings.show_technician_name,
    show_date: settings.show_estimate_date,
    show_quantity_and_unit_price: settings.show_quantity_and_unit_price,
    show_amount: settings.show_line_item_price,
    show_company_name: settings.show_company_name,
    show_logo: settings.show_company_logo,
    show_message_from_pro: settings.show_message_from_pro
  };
  var hasLineItems = ObjectHelper.isPresent(materialItems) || ObjectHelper.isPresent(laborItems);
  return React__default["default"].createElement(Grid, {
    container: true,
    spacing: 24
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(OptionInvoiceHeader, {
    option: option,
    customer: customer,
    address: address,
    organization: organization,
    pro: pro,
    preparedDate: preparedDate,
    settings: mappedSettings,
    isPresenting: isPresenting
  }), React__default["default"].createElement(VerticalSpace, {
    height: 8
  })), React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(OptionInvoiceDescription, {
    option: option,
    image: image
  }), React__default["default"].createElement(VerticalSpace, {
    height: 30
  })), React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(OptionInvoiceBody, {
    laborItems: laborItems,
    materialItems: materialItems,
    settings: mappedSettings
  }), React__default["default"].createElement(VerticalSpace, {
    height: 16
  }), React__default["default"].createElement(Divider["default"], null)), React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(OptionInvoiceFooter, {
    organization: organization,
    option: option,
    tax: tax,
    discounts: discounts,
    lendingPromo: lendingPromo,
    settings: mappedSettings,
    isPresenting: isPresenting,
    hasLineItems: hasLineItems
  })));
};
OptionInvoicePreview.defaultProps = {
  tax: {},
  discounts: {},
  pro: {},
  customer: {},
  laborItems: [],
  materialItems: [],
  image: {},
  lendingPromo: {}
};

module.exports = OptionInvoicePreview;
